export default __webpack_public_path__ + "static/media/Foto7.962f7552.png";